namespace RS.Logging
{
    /**
     * Whether each log level should show a stack trace.
     */
    const shouldAppendStackTrace =
    {
        [LogLevel.Debug]: false,
        [LogLevel.Info]: false,
        [LogLevel.Warn]: true,
        [LogLevel.Error]: true,
        [LogLevel.Fatal]: true,
        [LogLevel.None]: false
    };

    class DefaultLogger implements ILogger
    {
        public getContext(context: string)
        {
            return null;
        }

        /**
         * Logs the specified error.
         */
        public log(err: Error, logLevel?: LogLevel, excludeStackTrace?: boolean): void;

        /**
         * Logs the specified message.
         */
        public log(message: string, logLevel?: LogLevel, excludeStackTrace?: boolean): void;

        /**
         * Logs the specified message.
         */
        public log(obj: any, logLevel?: LogLevel, excludeStackTrace?: boolean): void
        {
            if (logLevel === undefined)
            {
                logLevel = LogLevel.Info;
            }

            let message: string;

            // Is it an error?
            if (obj instanceof Error)
            {
                if (logLevel === undefined) { logLevel = LogLevel.Error; }
                if (shouldAppendStackTrace[logLevel] && !excludeStackTrace)
                {
                    message = `${obj.message}\n${obj.stack || "No stack trace available"}`;
                }
                else
                {
                    message = obj.message;
                }
            }
            else
            {
                if (logLevel === undefined) { logLevel = LogLevel.Info; }
                if (shouldAppendStackTrace[logLevel] && !excludeStackTrace)
                {
                    message = `${obj}\n${Util.getStackTrace()}`;
                }
                else
                {
                    message = obj;
                }
            }

            // Write to console
            switch (logLevel)
            {
                case LogLevel.Debug:
                    console.debug(message);
                    break;

                case LogLevel.Info:
                    console.log(message);
                    break;

                case LogLevel.Warn:
                    console.warn(message);
                    break;

                case LogLevel.Error:
                case LogLevel.Fatal:
                    console.error(message);
                    break;
            }
        }
    }

    ILogger.register(DefaultLogger);
}